export default __webpack_public_path__ + "assets/media/Mid_Banner_TABLET.cd687a6d.webp";